import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  margin: auto;
  max-width: 1280px;
`

interface MainClientTemplateProps {
  children?: React.ReactNode
}

export const MainTemplate: React.FC<MainClientTemplateProps> = ({ children }) => (
  <Wrapper>{children}</Wrapper>
)
